import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Treebeard, decorators } from 'react-treebeard';
import { getLocalizedName } from '../../helpers';
import { cloneDeep } from 'lodash';
import Loader from './Loader';
import FileDeliveryService from '../../apiclients/FileDeliveryService';
import ContentService from '../../apiclients/ContentService';
import Icon from '@projeccions-pdc/react-icon';
import AppContext from '../../AppContext';
import { CategoryIcon, MetadocumentIcon, ExternalLinkIcon } from '../Search/Search';
import GroupSelectorWrapper from '../Visibilities/GroupSelectorWrapper';
import './Structure.css';

const treebeardStyle = {
    tree: {
        base: {
            margin: '15px',
            listStyle: 'none',
            backgroundColor: '#fff',
            padding: 0,
            color: '#000',
            fontFamily: 'inherit',
            fontSize: '14px'
        },
        node: {
            base: {
                position: 'relative'
            },
            link: {
                cursor: 'pointer',
                position: 'relative',
                padding: '0px 5px',
                display: 'block'
            },
            activeLink: {
                background: '#c9c9c9'
            },
            toggle: {
                base: {
                    position: 'relative',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    marginLeft: '-5px',
                    height: '24px',
                    width: '24px'
                },
                wrapper: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    margin: '-7px 0 0 -7px',
                    height: '14px'
                },
                height: 14,
                width: 14,
                arrow: {
                    fill: '#000',
                    strokeWidth: 0
                }
            },
            header: {
                base: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    color: '#000'
                },
                connector: {
                    width: '2px',
                    height: '12px',
                    borderLeft: 'solid 2px black',
                    borderBottom: 'solid 2px black',
                    position: 'absolute',
                    top: '0px',
                    left: '-21px'
                },
                title: {
                    lineHeight: '24px',
                    verticalAlign: 'middle'
                }
            },
            subtree: {
                listStyle: 'none',
                paddingLeft: '40px'
            },
            loading: {
                color: '#E2C089'
            }
        }
    }
};

class Structure extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
        };

        let language = new AppContext().getLanguage();
        this.configureDecorators(language);
    }

    componentDidMount() {
        if (this.props.isLoading) {
            this.props.isLoading(true);
        }
        this.loadTree();
    }

    loadTree = async (contentId, toggled, pathArray) => {
        let currNode;
        let copia;
        if (contentId === undefined) {
            let request;
            if (this.props.isInside) {
                request = FileDeliveryService.getContent(
                    undefined,
                    undefined,
                    undefined,
                );
            } else {
                request = ContentService.getContent(
                    undefined,
                );
            }
            currNode = await request;
            // if (this.isInFilter(currNode)) {
            copia = [currNode];
            // } else {
            //     copia = [];
            // }
        } else {
            copia = cloneDeep(this.state.data);
            currNode = this.findInOpenTree(contentId, copia, 'c').node;
        }

        let requests = [];
        let element;
        const ids = currNode.children;
        for (element in ids) {
            let subRequest;
            if (this.props.isInside) {
                subRequest = FileDeliveryService.getContent(
                    ids[element],
                    undefined,
                    undefined,
                );
            } else {
                subRequest = ContentService.getContent(
                    ids[element],
                );
            }
            requests.push(
                subRequest.then((data) => {
                    if (data.children && data.children.length === 0) {
                        data.children = undefined;
                    }
                    return data;
                }).catch((err) => {
                    console.log(err.message);
                    return undefined;
                })
            );
        }
        try {
            let responses = await Promise.all(requests);

            responses = responses.filter((content) => {
                return content !== undefined;
            });

            if (contentId !== undefined) {
                this.closeAllParalelItems(pathArray, copia);
                currNode.active = true;
            } else {
                currNode.isRoot = true;
                currNode.active = false;
                if (this.props.isLoading) {
                    this.props.isLoading(false);
                }
            }
            currNode.children = responses;
            currNode.loading = false;
            currNode.toggled = toggled !== undefined ? toggled : true;

            if (currNode.isRoot) {
                this.computeRootCategory(currNode, toggled, copia);
            }

            this.setState({ data: copia, cursor: currNode });
        } catch (err) {
            console.log(err.message);
        }

    }

    filterTreeData = (treeData) => {
        let newData = cloneDeep(treeData);
        newData = this.filterNodeData(newData);
        return newData;
    }

    filterNodeData = (children) => {
        children = children.filter((content) => {
            return this.isInFilter(content);
        });
        for (let i = 0; i < children.length; i++) {
            let currNode = children[i];
            if (currNode.children !== undefined && currNode.children.length > 0 && ((typeof currNode.children[0]) !== 'string')) {
                currNode.children = this.filterNodeData(currNode.children);
            }
        }
        return children;
    }

    isInFilter = (content) => {
        if (this.props.visibilityFilters === undefined || this.props.visibilityFilters.length === 0) {
            return true;
        }
        let index = this.props.visibilityFilters.indexOf(content.groupId);
        if (index !== -1 || content.groupId === undefined) {
            return true;
        }
        return false;
    }

    findInTree = (contentId, nodeArray, objectType) => {
        for (let node of nodeArray) {
            if (node.contentId === contentId && node.objectType === objectType) {
                return { node, pathArray: [node.contentId] };
            }
            let pathArray = [];

            let result = this.findInNode(contentId, node, objectType, pathArray);

            if (result) {
                pathArray.push(node.contentId);
                return { node: result, pathArray };
            }
        };
    }

    findInNode = (contentId, node, objectType, pathArray) => {
        let result;
        let rv;
        if (node.contentId === contentId && node.objectType === objectType) {
            return node;
        } else {
            if (node.children) {
                for (let child of node.children) {
                    if (child.contentId === contentId && child.objectType === objectType) {
                        pathArray.push(child.contentId);
                        return child;
                    }
                    if (child.objectType === 'c') {
                        rv = this.findInNode(contentId, child, objectType, pathArray);
                        if (rv) {
                            pathArray.push(child.contentId);
                            return rv;
                        }
                    }
                }
            }
        }
        return result;
    };

    findInOpenTree = (contentId, nodeArray, objectType) => {
        for (let node of nodeArray) {
            if (node.contentId === contentId && node.objectType === objectType) {
                return { node, pathArray: [node.contentId] };
            }
            let pathArray = [];
            if (node.toggled === true) {
                let result = this.findInOpenNode(contentId, node, objectType, pathArray);

                if (result) {
                    pathArray.push(node.contentId);
                    return { node: result, pathArray };
                }
            }
        };
    }

    findPathOfInOpenTree = (contentId, nodeArray, objectType) => {
        for (let node of nodeArray) {
            if (node.contentId === contentId && node.objectType === objectType) {
                return { node, pathArray: [node] };
            }
            let pathArray = [];
            if (node.toggled === true) {
                let result = this.findPathInOpenNode(contentId, node, objectType, pathArray);

                if (result) {
                    pathArray.push(node);
                    return { node: result, pathArray };
                }
            }
        };
    }

    findInOpenNode = (contentId, node, objectType, pathArray) => {
        let result;
        let rv;
        if (node.contentId === contentId && node.objectType === objectType) {
            return node;
        } else {
            if (node.children) {
                for (let child of node.children) {
                    if (child.contentId === contentId && child.objectType === objectType) {
                        pathArray.push(child.contentId);
                        return child;
                    }
                    if (child.objectType === 'c' && child.toggled === true) {
                        rv = this.findInOpenNode(contentId, child, objectType, pathArray);
                        if (rv) {
                            pathArray.push(child.contentId);
                            return rv;
                        }
                    }
                }
            }
        }
        return result;
    };

    findPathInOpenNode = (contentId, node, objectType, pathArray) => {
        let result;
        let rv;
        if (node.contentId === contentId && node.objectType === objectType) {
            return node;
        } else {
            if (node.children) {
                for (let child of node.children) {
                    if (child.contentId === contentId && child.objectType === objectType) {
                        pathArray.push(child);
                        return child;
                    }
                    if (child.objectType === 'c' && child.toggled === true) {
                        rv = this.findPathInOpenNode(contentId, child, objectType, pathArray);
                        if (rv) {
                            pathArray.push(child);
                            return rv;
                        }
                    }
                }
            }
        }
        return result;
    };

    computeRootCategory = (current, toggled, copia) => {
        for (let node of copia) {
            if (node.contentId === current.contentId && node.objectType === 'c') {
                if (toggled !== undefined) {
                    node.toggled = toggled;
                }
            } else {
                if (toggled) {
                    node.toggled = false;
                }
            }
        };
        this.setState({ currentRoot: current, data: copia });
    }

    closeAllParalelItems = (pathArray, copia) => {
        let tempPathArray = pathArray.reverse();
        tempPathArray.pop();
        let parent = tempPathArray.pop();
        let parentNode = this.findInOpenTree(parent, copia, 'c');
        if (parentNode && parentNode.node) {
            parentNode = parentNode.node;
            for (let child of parentNode.children) {
                child.toggled = false;
                child.active = false;
            };
        }
    }

    onToggle = (node, toggled) => {
        let copia = cloneDeep(this.state.data);
        if (this.state.cursor) {
            let cursor = this.findInOpenTree(this.state.cursor.contentId, copia, this.state.cursor.objectType).node;
            if (cursor) {
                cursor.active = false;
            }
        }
        const origNode = cloneDeep(node);
        let result = this.findInOpenTree(origNode.contentId, copia, origNode.objectType);
        node = result.node;
        let pathArray = result.pathArray;

        node.toggled = toggled;

        if (node.objectType === 'c' && node.children && node.children.length > 0 && typeof node.children[0] === 'string') {
            node.loading = true;
            this.loadTree(node.contentId, toggled, pathArray);
        } else {
            node.loading = false;
            if (node.isRoot) {
                this.computeRootCategory(node, toggled, copia);
            }
            this.closeAllParalelItems(pathArray, copia);
            if (node.children && node.children.length !== 0) {
                node.toggled = toggled;
            }
        }

        //if (node.objectType === 'm') {
        node.active = true;
        //}

        this.setState({ cursor: node, data: copia });
    }

    handleContentSelected = (node) => {
        if (this.props.onContentSelected) {
            // let res = this.findPathOfInOpenTree(this.state.cursor.contentId, this.state.data, this.state.cursor.objectType);
            //this.state.cursor, res.pathArray
            this.props.onContentSelected(node);
        }
    }

    updateNode = (content, newContent) => {
        let copia = cloneDeep(this.state.data);
        const origNode = cloneDeep(content);
        let result = this.findInOpenTree(origNode.contentId, copia, origNode.objectType);
        let aux = result.node;
        aux.groupId = newContent.groupId;
        this.setState({ data: copia });
    }

    configureDecorators = (language) => {
        this.customDecorators = cloneDeep(decorators);


        let getHeader = (style, node) => {
            let iconName;
            if (node.objectType === 'c') {
                iconName = CategoryIcon;
            } else if (node.objectType === 'm') {
                iconName = MetadocumentIcon;
            } else if (node.objectType === 'el') {
                iconName = ExternalLinkIcon;
            }
            return (
                <div style={style.base} onClick={() => this.handleContentSelected(node)} data-id={node.contentId} data-type="structure-content">
                    <div className='fe-nav-item'>
                        <Icon name={iconName} size={'20px'} primaryColor={'#979797'} />
                        <div className='fe-nav-item-name' dangerouslySetInnerHTML={{ __html: getLocalizedName(language, node.names) }} />
                        {this.props.showVisibility === true &&
                            <div className='fe-nav-item-group-container'>
                                <GroupSelectorWrapper
                                    disabled={this.props.canEditVisibility !== undefined ? !this.props.canEditVisibility : true}
                                    node={node}
                                    updateNode={(newNode) => this.updateNode(node, newNode)}
                                />
                            </div>
                        }
                    </div>
                </div>
            );
        };

        this.customDecorators.Toggle = (props) => {
            let style = {
                display: 'inline-block',
                position: 'absolute',
                top: '50%',
                transform: 'translate(0%,-50%)',
                left: '-15px',
                verticalAlign: 'middle',
                zIndex: 1,
                cursor: 'pointer',
                width: '25px',
                height: '20px',
                textAlign: 'center',
            };

            if (props.terminal !== true) {
                return (
                    <div style={style} onClick={props.onClick}>
                        <div className={props.node.toggled === true ? 'fe-nav-item-category-arrow rotate' : 'fe-nav-item-category-arrow'}></div>
                    </div >
                );
            } else {
                return ('');
            }
        };

        this.customDecorators.Loading = ({ style }) => {
            return <div style={style}>loading...</div>;
        };
        this.customDecorators.Container = (props) => {
            let Toggle = props.decorators.Toggle;

            return (
                <div style={{ position: 'relative' }}>
                    <Toggle {...props} />
                    {getHeader(props.style, props.node)}
                </div>
            );
        };
    }

    render() {
        const { data: stateData } = this.state;
        if (!stateData || stateData.length === 0) {
            return (
                <div className='pdc-structure-loadingContainer'>
                    <Loader loading={true} size='90px' />
                </div>
            );
        } else {
            return (
                <Treebeard
                    data={this.filterTreeData(stateData)}
                    decorators={this.customDecorators}
                    onToggle={this.onToggle}
                    style={treebeardStyle}
                />
            );
        }
    }
}
Structure.propTypes = {
    isInside: PropTypes.bool.isRequired,
    onContentSelected: PropTypes.func,
    isLoading: PropTypes.func,
    showVisibility: PropTypes.bool,
    canEditVisibility: PropTypes.bool,
    visibilityFilters: PropTypes.array,
};
export default Structure;